'use client'

import { useForm, Resolver } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useRouter } from 'next/navigation'
import LoginForm from './login-form'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs'
import { Card } from '@/shared/ui/card'
import { AuthPageHeading } from '@/shared/ui/headings'
import { paths } from '@/shared/routing'
import { buildUrlWithUtm } from '@/shared/lib/url-params'
import { fieldNames } from '@/shared/constants/field-names'
import { signIn } from 'next-auth/react'
import { toast } from '@/shared/ui/use-toast'
import { LoginDto, loginDto, loginSelectors, useLoginStore } from '../model'

export default function LoginCard() {
  const setLoading = useLoginStore(loginSelectors.selectSetLoading)

  const router = useRouter()
  const form = useForm<LoginDto>({
    resolver: zodResolver(loginDto) as unknown as Resolver<LoginDto>,
    defaultValues: {
      [fieldNames.EMAIL]: '',
      [fieldNames.PASSWORD]: '',
    },
  })

  async function onSubmit(data: LoginDto) {
    setLoading('loading')
    const res = await signIn('credentials', { redirect: false, ...data })
    if (res?.ok) {
      router.push(paths.authRedirect)
      router.refresh()
    } else {
      toast({
        variant: 'destructive',
        title: 'Что-то пошло не так!',
        description: res?.error || 'Вы не авторизовались!',
      })
    }

    setLoading('loaded')
  }

  const handleTab = (value: string) => router.push(buildUrlWithUtm(value))

  return (
    <Tabs onValueChange={handleTab} defaultValue={paths.login} className="max-w-[400px]">
      <Card className="relative px-[20px] sm:px-[40px] py-[40px] min-h-[480px] max-h-9dvh shadow-none border-none overflow-y-auto">
        <AuthPageHeading
          title={<>Вход или регистрация</>}
          description={<>Для продолжения необходимо войти в аккаунт</>}
        />
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value={paths.login}>Вход</TabsTrigger>
          <TabsTrigger value={paths.register}>Регистрация</TabsTrigger>
        </TabsList>
        <TabsContent value={paths.login} className="pt-5">
          <LoginForm {...form} onSubmit={onSubmit} />
        </TabsContent>
      </Card>
    </Tabs>
  )
}
